import { createContext, useEffect, useState } from "react";

export const AuthContxt = createContext()

export default function AuthContxtProvider({children}){
    const [UserLoggedIn , setUserLoggedIn] = useState(!!localStorage.getItem('token'))
     
    return <AuthContxt.Provider value={{UserLoggedIn , setUserLoggedIn}}>
      {children}
    </AuthContxt.Provider>
}